import React, { useState, useContext, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { Context } from '@store/store';
import {
  StyledBetaModal,
  StyledBetaModalHeader,
  StyledBetaModalContent,
  StyledBetaModalFooter,
} from './beta-sidebar.styles';

const BetaSidebar = () => {
  const [state, dispatch] = useContext(Context);
  const [markdown, setMarkdown] = useState(null);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/beta-modal-content.md')
      .then(res => res.text())
      .then(text => setMarkdown(text));
  }, []);

  return (
    <StyledBetaModal isOpened={state.isBetaModalOpened}>
      <StyledBetaModalHeader>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H17C18.3807 0.5 19.5 1.61929 19.5 3V17C19.5 18.3807 18.3807 19.5 17 19.5H3C1.61929 19.5 0.5 18.3807 0.5 17V3Z"
            fill="#FBFBFB"
            stroke="#FFB72D"
          />
          <path
            d="M7 6.95413C7.23606 6.30258 7.70199 5.75318 8.31527 5.40322C8.92855 5.05326 9.6496 4.92534 10.3507 5.0421C11.0518 5.15887 11.6878 5.51279 12.1459 6.04118C12.604 6.56957 12.8547 7.23833 12.8537 7.92901C12.8537 9.87878 9.84148 10.8537 9.84148 10.8537"
            stroke="#FFB72D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.92682 15H9.93901"
            stroke="#FFB72D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span>О бета-версии Читалки</span>
      </StyledBetaModalHeader>
      <StyledBetaModalContent>
        <ReactMarkdown source={markdown} />
      </StyledBetaModalContent>
      <StyledBetaModalFooter>
        <button
          onClick={() =>
            dispatch({ type: 'TOGGLE_BETA_MODAL', payload: false })
          }
        >
          Понятно
        </button>
      </StyledBetaModalFooter>
    </StyledBetaModal>
  );
};

export default BetaSidebar;
